var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row landing-cnt panel-cnt" },
    [
      _c("base-dialog", {
        attrs: {
          content: _vm.$t("patient-panel.go-360-decision"),
          okBtnText: _vm.$t("patient-panel.go-360"),
          cancelBtnText: _vm.$t("patient-panel.stay-opensalud"),
          okFn: function() {
            _vm.goTo360()
          },
          cancelFn: function() {
            _vm.app360DecisionModalForceHide = true
          },
          cancelBtnVariant: "info"
        },
        model: {
          value: _vm.show360DecisionModal,
          callback: function($$v) {
            _vm.show360DecisionModal = $$v
          },
          expression: "show360DecisionModal"
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-12 col-lg-6 my-lg-auto my-0 logged-ctn" },
        [
          _c("div", { staticClass: "logged-title-ctn mb-5" }, [
            _c("h1", { staticClass: "mb-4" }, [
              _vm._v(
                _vm._s(
                  _vm.$t("patient-panel.welcome", {
                    platform: _vm.getPlatformName
                  })
                )
              )
            ]),
            _vm._v(" "),
            _c("h3", { staticClass: "blue" }, [
              _vm._v(
                "\r\n            " +
                  _vm._s(_vm.$t("patient-panel.what-do-you-need")) +
                  "\r\n            "
              )
            ])
          ]),
          _vm._v(" "),
          _c("SimpleSearch", { attrs: { search360: _vm.show360Search } }),
          _vm._v(" "),
          _c("BackButton", { staticClass: "mt-3" })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f9bf7f0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f9bf7f0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/webapp/patient/PanelSearch.vue
// module id = 4044
// module chunks = 67